import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { SecondsToTimePipe } from './pipes/seconds-to-time.pipe';
import { ButtonModule } from "primeng/button";
import { RadioButtonModule } from 'primeng/radiobutton';
import { SidebarModule } from "primeng/sidebar";
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from "primeng/progressbar";
import { MultiSelectModule } from 'primeng/multiselect';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from "primeng/toast";
import { ThemeSelectorComponent } from "./components/theme-selector/theme-selector.component";
import { CardModule } from "primeng/card";
import { ImageModule } from 'primeng/image';
import { Paginator} from './helpers/paginator';
import { KeepOrderPipe } from "./pipes/keep-order.pipe";


@NgModule({
    declarations: [NotFoundComponent, SecondsToTimePipe, ThemeSelectorComponent,KeepOrderPipe],
    imports: [

        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        RadioButtonModule,
        SidebarModule,
        ProgressBarModule,
        InputTextModule,
        MultiSelectModule,
        ToastModule,
        MessagesModule,
        CardModule,
        ImageModule
    ],
    exports: [
        NotFoundComponent,
        TranslateModule,
        SecondsToTimePipe,
        ThemeSelectorComponent,
        KeepOrderPipe
        
    ],
    providers: [],
})
export class TmsToolsModule { }
